"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        subheader: {
            padding: spacing(2),
            paddingBottom: spacing(0.5)
        }
    });
});
var List = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.component, component = _b === void 0 ? 'ul' : _b, _c = _a.dense, dense = _c === void 0 ? false : _c, _d = _a.disablePadding, disablePadding = _d === void 0 ? false : _d, subheader = _a.subheader;
    var internalClasses = useStyles();
    return (react_1.default.createElement(List_1.default, __assign({ classes: classes, component: component, dense: dense, disablePadding: disablePadding }, subheader && { subheader: (react_1.default.createElement("div", { className: internalClasses.subheader }, subheader)) }), children));
};
exports.default = List;
